// extracted by mini-css-extract-plugin
export var closeButton = "_27-0";